"use client"

import { useState, useEffect } from "react"
import { Link } from "react-router-dom";
import "./EmailVerification.css"
import Header from "../../../layout/Header/Header";

const EmailVerification = () => {
  const [status, setStatus] = useState("loading") // 'loading', 'success', 'error'
  const [message, setMessage] = useState("")
  const [isAnimating, setIsAnimating] = useState(false)

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        // Get token from URL parameters
        const urlParams = new URLSearchParams(window.location.search)
        const token = urlParams.get("token")

        if (!token) {
          setStatus("error")
          setMessage("Invalid verification link. Please check your email and try again.")
          return
        }

        // Make API call to verify email
        const response = await fetch(`https://glo-backend.qwizfun.com/nimdee/verify-email?token=${token}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        })

        const data = await response.json()

        if (data.success) {
          setStatus("success")
          setMessage("Your email has been successfully verified!")
        } else {
          setStatus("error")
          setMessage(data.message || "Verification failed. Please try again.")
        }
      } catch (error) {
        setStatus("error")
        setMessage("Something went wrong. Please try again later.")
      }

      // Trigger animation after status is set
      setTimeout(() => setIsAnimating(true), 100)
    }

    verifyEmail()
  }, [])

  const handleResendVerification = () => {
    // You can implement resend logic here or redirect to a resend page
    alert("Please go back to the app to request a new verification link.")
  }

  const renderContent = () => {
    if (status === "loading") {
      return (
        <div className="verification-content loading">
          <div className="spinner"></div>
          <h2>Verifying your email...</h2>
          <p>Please wait while we verify your email address.</p>
        </div>
      )
    }

    if (status === "success") {
      return (
        <div className={`verification-content success ${isAnimating ? "animate" : ""}`}>
          <div className="success-icon">
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" fill="#10B981" />
              <path d="M9 12l2 2 4-4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <h2>Email Verified Successfully!</h2>
          <p>{message}</p>
          <div className="next-steps">
            <h3>What's next?</h3>
            <p>Go back to your mobile app to login and continue using the service.</p>
            <button className="cta-button" onClick={() => window.close()}>
              Close This Window
            </button>
          </div>
        </div>
      )
    }

    if (status === "error") {
      return (
        <div className={`verification-content error ${isAnimating ? "animate" : ""}`}>
          <div className="error-icon">
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" fill="#EF4444" />
              <path
                d="M15 9l-6 6M9 9l6 6"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <h2>Verification Failed </h2>
          <p>{message}</p>
          <div className="error-actions">
            {/* <button className="resend-button" onClick={handleResendVerification}>
              Request New Verification Link
            </button> */}
            <p className="help-text">If you continue to have issues, please contact support.</p>
            <div className="flex flex-col justify-between">
              
                        <a target="blank" href="https://wa.me/message/ZCUZ2NCAZQSON1"> whatsApp </a> <br/>
			
                        <a href="mailto: support@9ijakids.com">
                            Email:  support@9ijakids.com
                        </a>
            </div>
          </div>
        </div>
      )
    }
  }

  return (
    <>
    <Header />
       <main className="body">
<div className=" verification-container">
      <div className="verification-card">
        <div className="header">
          <h1>Email Verification</h1>
        </div>
        {renderContent()}
      </div>
    </div>
    </main></>
 
    
  )
}

// Make sure to export as default
export default EmailVerification
